/**
 * XAdkProvider Compound Components
 *
 * 提供可组合的子组件,用于构建自定义聊天界面
 */

export { default as Header } from './Header';
export { default as Sidebar } from './Sidebar';
export { default as Messages } from './Messages';
export { default as Sender } from './Sender';
export { default as Chatbot } from './Chatbot';
export { default as DefaultLayout } from './DefaultLayout';

export type { XAdkHeaderProps } from './Header';
export type { XAdkSidebarProps } from './Sidebar';
export type { XAdkMessagesProps } from './Messages';
export type { XAdkSenderCompoundProps } from './Sender';
export type { XAdkChatbotCompoundProps } from './Chatbot';
export type { DefaultLayoutProps } from './DefaultLayout';
